import { ClarityType } from '../clarityValue';
const trueCV = () => ({ type: ClarityType.BoolTrue });
const falseCV = () => ({ type: ClarityType.BoolFalse });
export { trueCV, falseCV };
//# sourceMappingURL=booleanCV.js.map